const CPF_LENGTH = 11;
const CNPJ_LENGTH = 14;

export const formatPadStartCpf = (cpf: string) => {
	if (cpf.length === CPF_LENGTH) {
		return cpf;
	}

	return cpf.padStart(CPF_LENGTH, '0');
};

export const formatPadStartCnpj = (cnpj: string) => {
	if (cnpj.length === CNPJ_LENGTH) {
		return cnpj;
	}

	return cnpj.padStart(CNPJ_LENGTH, '0');
};
